import React, { useState } from "react";
import Swal from "sweetalert2";
import { Spin } from "antd";
import { getApiBaseUrl, ADD_ACTIVITY, LOGIN } from "../Config/Config";

const AddPrinter = () => {
  const [formData, setFormData] = useState({
    name: "",
    ipadress: "",
  });
  const [loading, setLoading] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAuth = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setAuthLoading(true);
    setError("");

    try {
      if (!user?.UserName) {
        throw new Error("User name not found in session data.");
      }

      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await performAdd();
      } else {
        throw new Error(
          data.Message || "Invalid credentials. Please try again."
        );
      }
    } catch (err) {
      setError(err.message || "Unable to authenticate. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  const performAdd = async () => {
    if (!user?.UserID) {
      Swal.fire(
        "Error",
        "User session not found. Please log in again.",
        "error"
      );
      return;
    }

    setLoading(true);

    const payload = {
      name: formData?.name,
      ipadress: formData?.ipadress,
      createdby: user?.UserID,
    };

    const logActivity = async (isSuccess, note) => {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user.UserID,
            PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
            Notes: note,
            Location: "addPrinter",
            IsSucces: isSuccess ? 1 : 0,
          }),
        });
      } catch (err) {
        console.error("Failed to log activity:", err);
      }
    };

    try {
      const response = await fetch(
        `${getApiBaseUrl()}/api/AddprinterIpAdress`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      const status = result?.ResultData?.[0];

      if (response.ok && status?.Status === "Success") {
        await logActivity(
          true,
          `Printer "${formData.name}" created successfully`
        );
        await Swal.fire("Success", "Printer added successfully!", "success");
        setFormData({ name: "", ipadress: "" });
        window.location.reload();
      } else {
        await logActivity(
          false,
          `Printer "${formData.name}" creation failed`
        );
        await Swal.fire("Failed", "Something went wrong!", "error");
      }
    } catch (error) {
      console.error("Network error:", error);
      await logActivity(
        false,
        `Printer "${formData.name}" creation failed: ${error.message}`
      );
      await Swal.fire("Error", "Unable to connect to server.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user?.UserID) {
      setError("Invalid user data. Please log in again.");
      Swal.fire({
        icon: "error",
        title: "User Data Error",
        text: "Invalid user data. Please log in again.",
      });
      return;
    }

    setAskPassword(true);
  };

  return (
    <>
      <style>
        {`
          @media (max-width: 576px) {
            #AddPrinterOffcanvas {
              width: 90% !important;
            }
          }
          @media (min-width: 577px) and (max-width: 992px) {
            #AddPrinterOffcanvas {
              width: 55% !important;
            }
          }
          @media (min-width: 993px) and (max-width: 1440px) {
            #AddPrinterOffcanvas {
              width: 24% !important;
            }
          }
          @media (min-width: 1441px) {
            #AddPrinterOffcanvas {
              width: 15% !important;
            }
          }
        `}
      </style>

      {(loading || authLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="AddPrinterOffcanvas"
      >
        <form onSubmit={handleSubmit}>
          <div className="offcanvas-header">
            <h5 className="offcanvas-title">Add Printer</h5>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <div className="offcanvas-body">
            <div className="mb-3">
              <label className="form-label">Printer Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="form-control"
                placeholder="Enter printer name"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">IP Address</label>
              <input
                type="text"
                name="ipadress"
                value={formData.ipadress}
                onChange={handleInputChange}
                className="form-control"
                placeholder="Enter IP address (e.g., 192.168.1.10)"
                required
              />
            </div>
            {askPassword && (
              <div className="mt-2">
                <div className="mb-3 w-lg-75 m-auto">
                  <label className="form-label">
                    Confirm Password <span className="text-danger"> *</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="pass-input form-control"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setError("");
                      }}
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      placeholder="Enter Password"
                    />
                    <span
                      className={`ti toggle-password ${
                        showPassword ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                    ></span>
                  </div>
                </div>
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={handleAuth}
                  disabled={authLoading || !password}
                >
                  {authLoading ? "Verifying..." : "Confirm"}
                </button>
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setAskPassword(false);
                    setPassword("");
                    setError("");
                  }}
                >
                  Cancel
                </button>
              </div>
            )}

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default AddPrinter;